module.exports = __webpack_public_path__ + "static/media/refund-active.ce739204.svg";